/*
	Layout component with Sidebar and Header
	Uses react-router-dom's Outlet for nested routes
	Handles scroll to top on route change
*/

import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import WorkflowHost from '../common/components/WorkflowHost/WorkflowHost';

// Layout component
const Layout: React.FC = () => {
	// Ref for the main content area
	const mainRef = useRef<HTMLDivElement>(null);
	const location = useLocation();

	useEffect(() => {
		// Scroll to top on route change
		if (mainRef.current) {
			mainRef.current.scrollTop = 0;
		}
	}, [location.pathname]);

	// Render the layout with sidebar, header, and main content area
	return (
		<div className="flex h-screen overflow-hidden">
			<WorkflowHost />
			<Sidebar />
			<div className="flex-1 flex flex-col min-h-0">
				<Header />
				<main
					ref={mainRef}
					className="flex-1 p-6 bg-gray-100 overflow-y-auto overflow-x-hidden"
				>
					<Outlet />
				</main>
			</div>
		</div>
	);
};

// Export the component
export default Layout;
